import * as React from 'react';
import styled from 'react-emotion';
import { styles } from './styles';

export const CheckboxComponent = styled<'input'>('input')<React.InputHTMLAttributes<{}>>(({ checked }) => {
  return styles.checkbox(checked || false);
});

interface Props {
  label?: JSX.Element;
}

export const Checkbox: React.SFC<Props & React.InputHTMLAttributes<{}>> = props => (
  <div className={styles.checkboxWrapper}>
    <CheckboxComponent type={'checkbox'} {...props} checked={props.checked} />
    {props.label}
  </div>
);
